<template>
    <div class="tableTempleteBox">
        <el-table :data="tableDataVal" ref="tableList" border highlight-current-row size="mini" height="100%" 
            :header-cell-style="{background:'#f4f5f9',color:'#000'}"
            style="width:100%;"
            @row-click="toggleSelection" @selection-change="selectionChange"
        >
            <el-table-column type="index" align='center' label="序号" width="50"></el-table-column>
            <template v-for="(item,index) in tableColVal">
                <el-table-column :key="index" :label="item.label" :width="item.width+'rem'" :prop="item.name" show-overflow-tooltip></el-table-column>
            </template>
        </el-table>
    </div>
</template>
<script>
export default {
    props:{
        tablecol:{
            type:Array
        },
        tabledata:{
            type:Array
        }
    },
    mounted(){
    },
    data(){
        return{
            tableColVal:this.tablecol,
            tableDataVal:this.tabledata
        }
    },
    methods:{
        toggleSelection(row) {
            this.$refs.tableList.toggleRowSelection(row);
        },
        selectionChange(row){
            this.$emit("getRow",row)
        },
        deleteF(id){
            this.$emit("getTableDelete",id)
        },
        see(id){
            this.$emit("getTableSee",id)
        },
        edit(id){
            this.$emit("getTableEdit",id)
        },
        rowClick(id){
            this.$emit("rowClick",id)
        }
    } 
}
</script>
<style scoped>

</style>